module.exports = __webpack_public_path__ + "media/images/logo_text-dd0ca6e88436d297653ea33fdb0fadc6.jpg";